import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import Radium from 'radium';
import { UTLabel } from '@widergy/energy-ui';

import styles from './styles';

function SecondaryTopbar({
  titleText,
  titleIcon,
  iconAltText,
  whiteIcon,
  route,
  titleStyle,
  children,
  style
}) {
  const image = (
    <img src={titleIcon} alt={iconAltText} style={whiteIcon ? styles.iconInverted : styles.icon} />
  );

  return (
    <div style={[styles.topBar, style]}>
      <div style={styles.title}>
        {titleIcon && (route ? <Link to={route}>{image}</Link> : image)}
        <UTLabel large bold style={titleStyle}>
          {titleText}
        </UTLabel>
      </div>
      {children}
    </div>
  );
}

SecondaryTopbar.propTypes = {
  titleText: PropTypes.string.isRequired,
  titleIcon: PropTypes.string,
  iconAltText: PropTypes.string,
  whiteIcon: PropTypes.bool,
  route: PropTypes.string,
  titleStyle: PropTypes.any // eslint-disable-line react/forbid-prop-types
};

export default Radium(SecondaryTopbar);
